import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  inject,
} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SpuFormWrapperComponent } from '../../components/spu-form-wrapper/spu-form-wrapper.component';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import {
  SpuFormConfig,
  SPU_HEADER_ACTIONS,
  PACKAGE_SPU_PROPERTY_TABLE_SECTION,
  createSpuFormFields,
} from '../../spu.config';

@Component({
  selector: 'app-package-spu-edit',
  standalone: true,
  imports: [SpuFormWrapperComponent],
  templateUrl: './package-spu-edit.component.html',
  styleUrls: ['./package-spu-edit.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageSpuEditComponent implements CanComponentDeactivate {
  private readonly translateService = inject(TranslateService);
  @ViewChild(SpuFormWrapperComponent)
  private spuFormWrapper?: SpuFormWrapperComponent;

  config: SpuFormConfig = {
    title: this.translateService.instant(
      'goods.spu.form.titles.edit_package_product',
    ),
    formFields: createSpuFormFields(true, this.translateService), // true = package
    tableSections: [PACKAGE_SPU_PROPERTY_TABLE_SECTION],
    headerActions: SPU_HEADER_ACTIONS,
    listRoute: '/goods/spu/package',
    spuType: 'package',
  };

  canDeactivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    void currentRoute;
    void currentState;
    void nextState;

    return this.spuFormWrapper?.canDeactivate() ?? true;
  }
}
